import gql from 'graphql-tag';

export const destinationCarouselFragments = {
    RecommendedDestinationResponse: gql`
        fragment DestinationCarouselRecommendedDestinationResponse on RecommendedDestinationResponse {
            clientRequestId
            recommendedDestinations {
                searchTermUuid
                imageHref
                recommendationModel
                breadcrumbs {
                    place {
                        name {
                            simple
                            full
                        }
                    }
                }
            }
        }
    `,
};
